<template>

  <f7-block v-if="stationData" :class="{'margin-top-half': stationData.icon_id !== 0}">

    <h2 class="text-align-center text-uppercase margin-bottom-half">{{ stationMeta.station_name }}</h2>
    <div class="text-align-center text-uppercase">Aktuálne počasie o <strong class="apoc-size-wind">{{ stationData.dt*1000 | moment('HH:mm') }}</strong></div>
    <div class="text-align-center text-small text-color-gray text-capitalize">{{ stationData.dt*1000 | moment('dddd - DD.MM.YYYY') }}</div>

    <shmu-icon v-if="stationData.icon_id !== 0"  :iconId="stationData.icon_id" :iconType="this.iconType" icon-class="apoc-icon-size"></shmu-icon>
    <h3 class="text-align-center text-uppercase no-margin" v-if="stationData.synop_n != null">{{ stationData.synop_n }}</h3>
    <h5 class="font-weight-normal text-align-center text-uppercase no-margin" v-if="stationData.synop_ww != null"><em>{{ stationData.synop_ww }}</em></h5>

    <div class="margin-top-half display-flex justify-content-center">
      <div class="text-align-center">
        <h4 class="text-uppercase margin-bottom-half mt-0 font-weight-normal">Teplota</h4>
        <div class="display-flex align-items-flex-start justify-content-center">
          <strong class="apoc-size-temp">{{ stationData.ttt }}</strong><span class="apoc-size-temp-cel">°C</span>
        </div>
      </div>
      <div class="text-align-center ml-4 a-wind">
        <h4 class="text-uppercase margin-bottom-half mt-0 font-weight-normal">Vietor</h4>
        <strong v-if="windKmh !== null" class="apoc-size-wind text-nowrap">{{ windKmh }} km/h</strong><br>
        <template v-if="stationData.v_smer !== null && stationData.v_smer !== 'BEZV'">
            <img src="static/shmu/img/svg/wind-b.svg" :class="'img-wind rot-'+stationData.v_smer.toLowerCase()">
        </template>
        <template v-else>
          <small>bezvetrie</small>
        </template>


      </div>
    </div>

    <div class="display-flex justify-content-center margin-top">
      <table class="apoc-table">
        <tr v-if="stationData.fm != null"><td>Nárazy vetra:</td><td class="text-nowrap"><strong>{{ stationData.fm }} m/s</strong>
          <span v-if="windNarazyKmh !== null"><span class="text-small color-gray">({{ windNarazyKmh }} km/h)</span><br></span>
        </td></tr>
        <tr v-if="stationData.tlak != null"><td>Tlak:</td><td class="text-nowrap"><strong>{{ stationData.tlak }} hPa</strong></td></tr>
        <tr v-if="stationData.zra != null"><td>Úhrn zrážok za 6h:</td><td class="text-nowrap"><strong>{{ stationData.zra }} mm</strong></td></tr>
        <tr  v-if="stationData.rh != null || parseInt(stationData.rh) !== -1000"><td>Relatívna vlhkosť:</td><td class="text-nowrap"><strong>{{ stationData.rh }}%</strong></td></tr>
      </table>
    </div>

  </f7-block>

</template>

<script>

import shmuIcon from "../components/shmu-icon";

export default {
  name: 'aktualne-pocasie-mesto',
  components: {
    'shmu-icon' :shmuIcon,
  },
  props: [
    'stationMeta',
    'stationData',
  ],


  computed: {
    iconType: function () {
      let hh = this.$moment.unix(this.stationData.dt).format('H');
      if (hh < 7 || hh > 19) return 'noc';
      return 'den';
    },
    windKmh: function () {
      if (this.stationData.v_rychlost) {
        return Math.round(this.stationData.v_rychlost * 3.6 * 10) / 10;
      }
      return null;
    },
    windNarazyKmh: function () {
      if (this.stationData.fm) {
        return Math.round(this.stationData.fm * 3.6 * 10) / 10;
      }
      return null;
    }
  }
}

</script>


<style lang="scss">



.apoc-table {
  font-size: 1rem;
  border: 0;
  border-collapse: collapse;
  td {
    padding: 5px 10px; border: 0; border-bottom: 1px solid var(--f7-list-border-color);
    &:first-child {
      text-align: right;
    }
    &:last-child {
      text-align: left;
    }
  }
}

.apoc-size-temp {
  font-size: 65px;
  line-height: 56px;
}

.apoc-size-temp-cel {
  font-size: 20px;
}

.apoc-size-wind {
  font-size: 20px;
  line-height: 25px;
}

.apoc-icon-size {
  width: 200px;
  height: 200px;
}

</style>

